import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'
import { Button, Card, TextMax, TextM, TextS, WhiteSpace, Hr } from '../../components'
import { useCvcdExit } from '../../hook/merchant/useMerchant'

export default function CvcdExit() {
    const { t } = useTranslation()
    const action = useCvcdExit()
    const { summary } = action
    const data = summary.data
    const ready = summary.hasData && !summary.error
    return <Container>
        <TextMax>{t('CVCD Swap Early Unlock')}</TextMax>
        <WhiteSpace />
        <Card>
            <TextS block>{t('Receive remaining CVC and refundable CVCD in one transaction, without approval or waiting for the CVC lock period.')}</TextS>
            <WhiteSpace />
            <TextM block>{t('CVC Refund')}: {ready ? data.cvc : '--'} CVC</TextM>
            <TextM block>{t('CVCD Refund')}: {ready ? data.cvcd : '--'} CVCD</TextM>
            <TextS block>{t('Refund amounts come from the contract. Already received USDT is deducted; unreceived CVC deposits are excluded.')}</TextS>
            <TextS block>{t('Refunds depend on available inventory and successful token delivery. A failed transaction pays neither asset.')}</TextS>
            <WhiteSpace />
            {ready && data.claimed ? <TextM role='status'>{t('Exit refund has already been claimed.')}</TextM> : <Button {...action.button} />}
            {summary.error && <>
                <WhiteSpace />
                <TextS block fail role='alert'>{t(summary.error.message)}</TextS>
            </>}
            {action.error && <>
                <WhiteSpace />
                <TextS block fail role='alert'>{t(action.error)}</TextS>
            </>}
        </Card>
        <WhiteSpace />
        {ready && <Card>
            <TextM>{t('CVC Stake History')}</TextM>
            {data.stakes.map(order => <TextS block key={order.id}>#{order.id + 1}: {order.amount} CVC · {t(order.claimed ? 'Claimed' : 'Not Claimed')}</TextS>)}
            <WhiteSpace /><Hr /><WhiteSpace />
            <TextM>{t('My USDT Release Orders')}</TextM>
            {data.releases.map(order => <TextS block key={order.id}>#{order.id + 1}: {order.amount} USDT · {t('Released')}: {order.released} USDT</TextS>)}
        </Card>}
    </Container>
}
